import Vue from 'vue';

const success = (context) => {
  context.rental.invoice_logo = null;
  $(".images-rentals").find(".dropify-wrapper").find('.dropify-clear').click();
  toastr.success(context.$t("rentals.detail.invoice_logo_deleted"));
  context.invoiceLogoIsDeleting = false;

};

const failed = (context, error) => {
  context.showToasterError(error);
};

export default (context, id) => {
  return Vue.$http.delete('/rentals/delete-invoice-logo/'+id)
        .then(response => {
            if(response && response.status === 200) {
              success(context);
            }
        }).catch(error => {
             failed(context, error);
        })
}



// WEBPACK FOOTER //
// ./src/app/services/rental/deleteInvoiceLogo.js